import { render } from "./workorder-item.vue?vue&type=template&id=70e5273d"
import script from "./workorder-item.vue?vue&type=script&lang=js"
export * from "./workorder-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__